var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckboxWhile24X24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6944 0.870081C12.1019 1.27758 12.1019 1.93828 11.6944 2.34578L4.91176 9.12839C4.50426 9.53589 3.84357 9.53589 3.43606 9.12839L0.305628 5.99796C-0.101876 5.59045 -0.101876 4.92976 0.305628 4.52225C0.713131 4.11475 1.37383 4.11475 1.78133 4.52225L4.17391 6.91484L10.2187 0.870081C10.6262 0.462577 11.2869 0.462577 11.6944 0.870081Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxWhile24X24);
export default __webpack_public_path__ + "static/media/CHECKBOX_WHILE_24X24.ccfa66189eb4dc14ff884c7d42af21b2.svg";
export { ForwardRef as ReactComponent };